import { getSettingsGeneralListWatcherSaga } from './get.saga'
import { updateSettingsGeneralWatcherSaga } from './update.saga'
import { addDefaultProfilesWatcherSaga } from './addDefaultProfilesBulkAction.saga'
import { defaultprofilesListWatcherSaga } from './getDefaultProfilesList.saga'
import { getIntegrationsWatcherSaga } from './getIntegrations'

export const sagas = [
  getSettingsGeneralListWatcherSaga(),
  updateSettingsGeneralWatcherSaga(),
  addDefaultProfilesWatcherSaga(),
  defaultprofilesListWatcherSaga(),
  getIntegrationsWatcherSaga(),
]

export default sagas
